import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { taskApi } from '../api';
import { Spinner, EmptyState } from '../components/ui';

export default function DeadlineMissed() {
  const navigate           = useNavigate();
  const [tasks,   setTasks]  = useState([]);
  const [loading, setLoading]= useState(true);
  const [search,  setSearch] = useState('');

  useEffect(() => {
    taskApi.getOverdue()
      .then(r => setTasks(r.data.data || []))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  const filtered = tasks
    .filter(t => !search || t.title?.toLowerCase().includes(search.toLowerCase())
                          || t.assignedTo?.name?.toLowerCase().includes(search.toLowerCase()))
    .sort((a, b) => (b.daysOverdue || 0) - (a.daysOverdue || 0));   // oldest overdue first

  return (
    <div style={{ padding: '24px', maxWidth: '800px' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '20px' }}>
        <span style={{ fontSize: '28px' }}>⏰</span>
        <div>
          <h1 style={S.title}>Deadline Missed</h1>
          <p style={S.sub}>{tasks.length} overdue task{tasks.length !== 1 ? 's' : ''} — oldest first</p>
        </div>
      </div>

      <div style={{ padding: '12px 16px', background: '#FFF5F5', border: '1px solid #FEB2B2', borderRadius: 'var(--radius-md)', marginBottom: '16px', fontSize: '13px', color: 'var(--color-danger)', lineHeight: 1.5 }}>
        These tasks have passed their deadline and are not yet completed. They stay here until marked Done.
      </div>

      <input
        placeholder="Search by task or employee..."
        value={search}
        onChange={e => setSearch(e.target.value)}
        style={{ ...S.input, marginBottom: '16px' }}
      />

      {loading ? (
        <div style={{ display: 'flex', justifyContent: 'center', padding: '40px' }}><Spinner /></div>
      ) : filtered.length === 0 ? (
        <EmptyState icon="✓" title={search ? 'No results' : 'No overdue tasks'} subtitle={!search ? 'All tasks are on track.' : ''} />
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
          {filtered.map(task => (
            <div key={task.id} onClick={() => navigate(`/tasks/${task.id}`)} style={{
              background: 'var(--color-surface)', borderRadius: 'var(--radius-md)',
              border: '1px solid #FEB2B2', padding: '14px 16px', cursor: 'pointer',
              borderLeft: '4px solid var(--color-danger)',
              transition: 'box-shadow 0.15s',
            }}
              onMouseEnter={e => e.currentTarget.style.boxShadow = 'var(--shadow-md)'}
              onMouseLeave={e => e.currentTarget.style.boxShadow = 'none'}
            >
              <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: '12px' }}>
                <div style={{ flex: 1, minWidth: 0 }}>
                  <p style={{ fontWeight: 600, fontSize: '15px', marginBottom: '6px',
                    whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                    {task.title}
                  </p>
                  <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap', alignItems: 'center' }}>
                    <span style={{ fontSize: '11px', padding: '2px 8px', borderRadius: '999px', background: '#FFF5F5', color: 'var(--color-danger)', fontWeight: 600 }}>
                      OVERDUE
                    </span>
                    {task.department && (
                      <span style={{ fontSize: '12px', color: 'var(--color-text-muted)', background: 'var(--color-bg)', padding: '2px 8px', borderRadius: '999px' }}>
                        {task.department.name}
                      </span>
                    )}
                    {task.assignedTo
                      ? <span style={{ fontSize: '12px', color: 'var(--color-text-muted)' }}>→ {task.assignedTo.name}</span>
                      : <span style={{ fontSize: '12px', color: 'var(--color-warning)' }}>Unassigned</span>
                    }
                  </div>
                </div>
                <div style={{ textAlign: 'right', flexShrink: 0 }}>
                  <p style={{ fontSize: '14px', color: 'var(--color-danger)', fontWeight: 700 }}>
                    {task.daysOverdue}d overdue
                  </p>
                  <p style={{ fontSize: '12px', color: 'var(--color-text-muted)', marginTop: '2px' }}>
                    Was due {task.deadline}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

const S = {
  title: { fontSize: '22px', fontWeight: 600, color: 'var(--color-primary)', marginBottom: '2px' },
  sub:   { fontSize: '13px', color: 'var(--color-text-muted)' },
  input: { padding: '10px 14px', borderRadius: 'var(--radius-md)', border: '1.5px solid var(--color-border)', fontSize: '14px', width: '100%' },
};
